import { List, ListItem, ListItemText, Paper, Typography } from '@mui/material';
import { Link } from '@remix-run/react';
import { useCallback } from 'react';

const liftPortalComponents = [
  {
    name: 'Confirmation Dialog',
    path: '/showcase/components/confirmation-dialog',
  },
  {
    name: 'LIFT Portal Alert (style customizations of MUI Alert)',
    path: '/showcase/components/lift-portal-alert',
  },
];

const bulkImportComponents = [
  {
    name: 'Bulk import notification states',
    path: '/showcase/bulk-import/WIP/status-components',
  },
  {
    name: 'Bulk import tab controlled content',
    path: '/showcase/bulk-import/WIP/tab-controlled-content',
  },
];

export default function ShowcaseHomepage() {
  const renderListItemLink = useCallback(
    (entry: { name: string; path: string }) => (
      <ListItemLink key={entry.path} name={entry.name} path={entry.path} />
    ),
    []
  );

  return (
    <Paper sx={{ maxWidth: 600, mx: 'auto', mt: 4, p: 3 }}>
      <Typography variant="header-xl" gutterBottom>
        Showcase
      </Typography>

      <List>
        <Typography variant="header-l">LIFT Portal components</Typography>
        {liftPortalComponents.map(renderListItemLink)}

        <Typography variant="header-l">LIFT Portal Components</Typography>
        {liftPortalComponents.map(renderListItemLink)}

        <Typography variant="header-l">Bulk import components</Typography>
        {bulkImportComponents.map(renderListItemLink)}
      </List>
    </Paper>
  );
}

function ListItemLink(props: { path: string; name: string }) {
  return (
    <ListItem
      key={props.path}
      component={Link}
      to={props.path}
      sx={{
        borderRadius: 1,
        '&:hover': {
          bgcolor: 'action.hover',
        },
      }}
    >
      <ListItemText
        primary={props.name}
        // secondary={props.description}
      />
    </ListItem>
  );
}
